import gql from 'graphql-tag'

export default gql`query project($project_id: String!){
  project(project_id: $project_id){
    project_id_prefix
    project_id
    name
    description
    total_budget
    total_fees
    total_hours_by_month{
      year
      month
      description
      total_minutes_worked
    }
    timesheets{
      id
      timesheet_date
      minutes_worked
      user{
        user_id
        full_name
      }
    }
    project_activity_budgets{
      id
      project_activity_type_id
      project_activity_type{
        description
      }
      description
      amount
      stage
      address{
        full_address
      }
      budget_total
      budget_used
      supplier_total
      breakdown{
        id
        description
        amount
        budget_used
      }
    }
    users_time_on_project{
      user_id
      first_name
      last_name
      total_minutes_worked
    }
    users_time_on_project_last_seven_days{
      user_id
      first_name
      last_name
      total_minutes_worked
      timesheet_date
    }
    future_user_schedules{
      id
      start_date
      end_date
      user_project_activities{
        user_project_activity_id
        project_activity_budget{
          id
          description
          project_activity_type{
            project_activity_type_id
            description
          }
        }
        detail
      }
      user{
        user_id
        full_name
      }
    }
    
  }

}`